<template>
    <modal
            ref="modal"
            :show-close-button="false"
            submit-value="OK"
            :title="headerTitle"
            modal-class="modal-msg"
            @ok="ok"
    ></modal>
</template>

<script>
    import Modal from './Modal'
    export default {
        name: "ClipboardModal",
        components: {
            Modal,
        },
        props: ['url'],
        data() {
            return {
                status: null,
            };
        },
        methods: {
            showModal() {
                this.$refs['modal'].show();
                this.$copyText(this.url).then(e => {
                    this.status = true;
                }, e => {
                    this.status = false
                });
            },
            ok() {
                this.$refs['modal'].close();
            }
        },
        computed: {
            headerTitle() {
                if (this.status === null) {
                    return '';
                }
                if (this.status) {
                    return 'The link has been copied to your clipboard';
                }
                return 'Cannot copy link to clipboard';
            }
        },
    }
</script>

<style scoped>

</style>